import { useState, useContext, useEffect } from 'react'
import { Box, Typography, ImageList, ImageListItem, Paper, Divider, Button, TextField } from '@material-ui/core'
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab'
import MultipleChoices from './Options/MultipleChoices'
import ConfirmationModal from '../ExaminationEditor/QuestionForms/SharedComponent/ConfirmationModal'
import { submitDeleteQuestion } from 'containers/Examination/ExaminationService'
import { ExamContext } from '../ExaminationContext'
import EditQuestion from '../ExaminationEditor/Edit/EditQuestion'
import { StateContext } from 'context/Provider'

import './QuestionItem.css'
import ShortAnswer from './Options/ShortAnswer'
import LongAnswer from './Options/LongAnswer'

const QuestionItem  = (props) => {
  const { question, onUpdate, onAnswerSelect, checking, updateStatus, updateScore, forceReadOnly } = props
  const appState = useContext(StateContext)
  const { authState } = appState
  const examContext = useContext(ExamContext)
  const [editModalState, setEditModalState] = useState('closed')
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  const [answer, setAnswer] = useState(null)
  const [originalCalculatedScore, setOriginalCalculatedScore] = useState(question.calculated_score)

  const getSelectedAnswer = () => {
    return question.answer
  }

  const deleteQuestion = () => {
    submitDeleteQuestion(examContext.exam.id, question.id)
    onUpdate()
  }

  const updateQuestionStatus = (questionId, newStatus) => {
    updateStatus(questionId, newStatus)
  }

  const updateAnswerScore = (questionId, pts, maxPts) => {
    if (pts > maxPts) return
    updateScore(questionId, pts)
  }

  const handleClose = (refreshQuestions = false) => {
    setEditModalState('closed')

    if (refreshQuestions) {
      onUpdate()
    }
  }

  const readOnly = () => {
    if (forceReadOnly !== undefined) {
      return true;
    }

    if (authState.user.role_id === 5) {
      return false
    }

    if (!isChecking()) {
      return false
    }

    return true
  }

  const isChecking = () => {
    if (checking === undefined) {
      return false
    }

    if (checking === true) {
      return true
    }

    return false
  }

  useEffect(() => {
    if (onAnswerSelect !== undefined && answer !== undefined && answer !== null) {
      onAnswerSelect(question.id, answer)
    }
  }, [answer])

  useEffect(() => {
    console.log('question updated')
    setOriginalCalculatedScore(question.calculated_score)
  }, [question])

  return (
    <Paper elavation={3} style={{marginBottom: '20px'}}>

      <EditQuestion
        modalState={editModalState}
        onClose={handleClose}
        question={question}
      />

      <ConfirmationModal
        show={showDeleteConfirmation}
        onClose={() => setShowDeleteConfirmation(false)}
        onConfirm={deleteQuestion}
      />

      <Box>
        {authState.user.role_id === 4 && isChecking() && <>
          <Box style={{display: 'flex'}}>
            <Box style={{padding: '10px', flexBasis: '25%', display: 'flex'}}>
              <Box style={{display: 'flex', alignItems: 'center', paddingRight: '10px'}}>
                <Typography style={{textAlign: 'center'}}>
                  Points (max {question.pts} pts)
                </Typography>
              </Box>
              <TextField
                className="checking_score-field"
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                value={question.calculated_score}
                variant="outlined"
                size="small"
                max={10}
                onChange={(e) => {
                  updateAnswerScore(question.id, e.target.value, question.pts)
                }}
                onBlur={(e) => {
                  if (e.target.value === "") {
                    console.log(originalCalculatedScore)
                    updateAnswerScore(question.id, originalCalculatedScore, question.pts)
                  }
                }}
              />

            </Box>
            <Box style={{flexGrow: '1'}}></Box>
            <Box style={{padding: '10px'}}>
              <ToggleButtonGroup value={question.correct ? 'correct' : 'incorrect'} size="small" className="correctness-toggle">
                <ToggleButton value="correct" className="correct" onClick={() => updateQuestionStatus(question.id, 'correct')}>
                  Correct
                </ToggleButton>
                <ToggleButton value="incorrect" className="incorrect" onClick={() => updateQuestionStatus(question.id, 'incorrect')}>
                  Incorrect
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Box>
          <Divider />
        </>}

        <Box>
          <Box display="flex" style={{padding: '10px'}}>
            <Box flexGrow={1}>
              <Typography variant="body1" className="presentation__description">
                {question.description} ({question.pts} pts) {isChecking() && (
                  <span className={question.correct ? 'checking__correct' : 'checking__incorrect'}>[{question.correct ? 'Correct' : 'Incorrect'}]</span>
                )}
              </Typography>
            </Box>
            {authState.user.role_id === 4 && !isChecking() &&
              <Box className="presentation__question-actions">
                <Button color="primary" onClick={() => setEditModalState('open')}>
                  <i className="fa fa-edit"></i>
                </Button>
                <Button color="primary" onClick={() => setShowDeleteConfirmation(true)}>
                  <i className="fa fa-trash"></i>
                </Button>
              </Box>
            }

            {/* {authState.user.role_id === 4 && isChecking() &&
              <Box className="presentation__question-actions">
                <Button className={`checking__correct ${question.correct ? 'outlined' : ''}`} onClick={() => updateQuestionStatus(question.id, 'correct')}>
                  <i className="fa fa-check-circle"></i>  Correct
                </Button>
                <Button className={`checking__incorrect ${question.correct ? '' : 'outlined'}`} onClick={() => updateQuestionStatus(question.id, 'incorrect')}>
                  <i className="fa fa-times-circle"></i>  Incorrect
                </Button>
              </Box>
            } */}
          </Box>

          {question.images?.length > 0 &&
            <Box style={{padding: '10px'}}>
              <ImageList rowHeight={200} cols={2}>
                {question.images.map((i) => (
                  <ImageListItem key={i.id}>
                    <img src={i.photo_url} alt="Question description" />
                  </ImageListItem>
                ))}
              </ImageList>
            </Box>
          }

          <Divider />

          <Box>
            {question.type === 'MULTIPLE_CHOICES' &&
              <MultipleChoices
                options={question.options}
                onSelect={(answer) => setAnswer(answer)}
                answer={getSelectedAnswer()}
                readonly={readOnly()}
              />
            }
            {question.type === 'SHORT_ANSWER' &&
              <ShortAnswer
                options={question.options}
                answerUpdate={(answer) => setAnswer(answer)}
                answer={getSelectedAnswer()}
                readonly={readOnly()}
              />
            }
            {question.type === 'LONG_ANSWER' &&
              <LongAnswer
                options={question.options}
                answerUpdate={(answer) => setAnswer(answer)}
                answer={getSelectedAnswer()}
                readonly={readOnly()}
              />
            }
          </Box>

          {question.bonus === 1 &&
            <Box display={`flex`} justifyContent={`center`} style={{backgroundColor: '#caf7cc'}}>
              <span>This is a bonus question</span>
            </Box>
          }
        </Box>
      </Box>
    </Paper>
  )
}

export default QuestionItem